// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpTabsHero-cls1_LI3","cls2":"LoswpTabsHero-cls2_q37 LoswpTabsHero-cls1_LI3"};